import { OnInit, ViewChild} from '@angular/core';
import {LoginService} from '../../../shared/services/login.service';
import {Router} from '@angular/router';
import {UploadfilesViewmodel} from '../../../shared/viewmodels/uploadfiles-viewmodel';
import {Steps} from 'primeng/primeng';
import {IppaymentService} from '../../../shared/services/ippayment.service';
import {ApplicationFormBase} from '../../../shared/data-objects/application-form-base';
import * as MenuUtils from '../../../shared/data-objects/menu-item-ex';
import {ServiceBase} from '../../../shared/services/service-base';
import {OwnerDetailsComponent} from '../../../shared/components/owner-details/owner-details.component';
import {User} from '../../../shared/data-objects/user';
import {LndBaseService} from '../lnd-base.service';
import {LndBase} from '../lnd-base';
import {FormControl, Validators} from '@angular/forms';

Steps.prototype.itemClick = MenuUtils.itemClick;

export abstract class LndBaseComponent<T extends  LndBase> extends ApplicationFormBase<LndBase> implements OnInit {
  imageSourceUrl = ServiceBase.baseHref + '/assets/images/pfi.png';
  applicationType: string;

  @ViewChild('OwnerDetailsComponent') owner: OwnerDetailsComponent;

  spearReferenceControl: FormControl;
  spearReferenceControlMaxLength = 100;
  spearReferenceControlMinLength = 1;

  constructor(protected loginService: LoginService,
              protected lndwService: LndBaseService<T>, protected ipPaymentService: IppaymentService, protected router: Router) {
    super(lndwService, loginService, ipPaymentService, router);
    this.spearReferenceControl = new FormControl({value: '', disabled: true}, [Validators.compose([
      Validators.required,
      Validators.maxLength(this.spearReferenceControlMaxLength),
      Validators.minLength(this.spearReferenceControlMinLength)
    ])]);
  }

  ngOnInit() {
    super.ngOnInit();
    this.subscribePaymentInit();
  }

  initSteps(stepOneCaption: string, stepTwoCaption: string, stepThreeCaption: string, stepFourCaption: string,
            stepFiveCaption: string, stepSixCaption: string, stepSevenCaption?: string) {
    const me = this;

    // if (this.loginService.isGuestUserLoggedIn()) {
    if (!this.loginService.isUserBillLater()) {
      // this.setApplicantDetailsForGuestUser(this.applicationService.applicationData.applicant);
      this.setApplicantDetailsForNonBillLater(this.applicationService.applicationData.applicant);  
    } else {
      this.setApplicantDetailsForBillLater(this.applicationService.applicationData.applicant); 
    }

    this.addMenuItem(stepOneCaption, me, 0, 'First Step');
    this.addMenuItem(stepTwoCaption, me, 1, 'Second Step');
    this.addMenuItem(stepThreeCaption, me, 2, 'Third Step');
    this.addMenuItem(stepFourCaption, me, 3, 'Fourth Step');
    this.addMenuItem(stepFiveCaption, me, 4, 'Fifth Step');
    this.addMenuItem(stepSixCaption, me, 5, 'Sixth Step');
    if(stepSevenCaption) {
      this.addMenuItem(stepSevenCaption, me, 6, 'Seventh Step');
    }
  }

  abstract subscribePaymentInit();

  onFeeCodesReceived(): void {
  }

  get isLandlineMandatory(): boolean {
    return true;
  }

  get controlLabel(): string {
    return 'Upload file';
  }

  get uploadfilesViewmodel(): UploadfilesViewmodel {
    return this.lndwService.uploadfilesViewmodel;
  }

  abstract navigateFromWorkRequest(executeYes: any, executeNo: any);

  abstract navigateFromUploadFiles(executeYes: any, executeNo: any);

  canGoNext(executeYes: any, executeNo: any) {
    this.lndwService.submitErrorMessage = '';
    this.location.errorMessage = '';
    if (this.activeIndex === 0) {
      if (this.applicationType === 'lnd-nw') {
        if (this.subdivisionYesrequired) {
          executeYes();
        } else {
          this.navigateFromLocationWithPlan(executeYes, executeNo);
        }
      } else {
        if (this.subdivisionYesrequired) {
          if (this.spearReferenceControl.invalid) {
            this.lndwService.submitErrorMessage += 'Please enter SPEAR Reference.';
            executeNo();
          } else {
            executeYes();
          }
        } else if (this.subdivisionNorequired) {
          this.navigateFromLocationWithPlan(executeYes, executeNo);
        }
      }
    } else if (this.activeIndex === 1) {
      this.navigateFromWorkRequest(executeYes, executeNo);
    } else if (this.activeIndex === 2) {
      this.navigateFromUploadFiles(executeYes, executeNo);
    } else if (this.activeIndex === 3) {
      if (this.owner.invalid && this.owner.displayErrorMessage().length > 0) {
        this.lndwService.submitErrorMessage += this.owner.displayErrorMessage();
        executeNo();
        return;
      }
      if (this.applicationType === 'lnd-nw') {
        this.applicationService.applicationData.applicant.email = this.owner.applicantDetails.email;
        this.applicationService.applicationData.applicant.landLine = this.owner.applicantDetails.landLine;
        this.applicationService.applicationData.applicant.mobile = this.owner.applicantDetails.mobile;
      }
      executeYes();
    } else if (this.activeIndex === 4) {
      if (this.applicant.invalid && this.applicant.displayErrorMessage().length > 0) {
        this.lndwService.submitErrorMessage += this.applicant.displayErrorMessage();
        executeNo();
        return;
      }
      this.validTermsAndConditions(executeNo, executeYes);
    // } else if (this.isGuestUserLoggedIn && !this.isPaymentByCheque && this.activeIndex === 5) {
    } else if (!this.loginService.isUserBillLater() && !this.isPaymentByCheque && this.activeIndex === 5) {
      // this.navigateToPaymentWhenGuestUser(executeYes, executeNo, this.getTotalOrderAmount(), this.submitApplication.bind(this));
      this.navigateToPaymentWhenNonBillLaterUser(executeYes, executeNo, this.getTotalOrderAmount(), this.submitApplication.bind(this));
    } else {
      executeYes();
    }
  }

  goNext(): void {
    // if (((!this.isGuestUserLoggedIn || this.isPaymentByCheque) && this.activeIndex === 4)
    //   || (this.isGuestUserLoggedIn && !this.isPaymentByCheque && this.activeIndex === 5)) {
    // if (((this.loginService.isUserBillLater() || this.isPaymentByCheque) && this.activeIndex === 4)
    //   || (!this.loginService.isUserBillLater() && !this.isPaymentByCheque && this.activeIndex === 5)) {
    //   return;
    // }

    if (this.activeIndex === 5) {
      return;
    }

    this.canGoNext(() => {
      this.activeIndex++;
    }, () => {
    });
  }

  canGoPrevious(): boolean {
    // if (this.isGuestUserLoggedIn && !this.isPaymentByCheque && (this.activeIndex === 6 || this.activeIndex === 0)) {
    if (!this.loginService.isUserBillLater() && !this.isPaymentByCheque && (this.activeIndex === 6 || this.activeIndex === 0)) {
      return false;
    }

    // if ((!this.isGuestUserLoggedIn || this.isPaymentByCheque) && this.activeIndex === 0) {
    if ((this.loginService.isUserBillLater() || this.isPaymentByCheque) && this.activeIndex === 0) {
      return false;
    }

    return true;
  }

  goPrevious(): void {
    if (!this.canGoPrevious()) {
      return;
    }

    this.activeIndex--;
  }

  submitApplication(callback): void {

    let validData = true;
    this.lndwService.submitErrorMessage = '';

    this.validateWorkRequest(validData);

    if (!this.uploadFileComponent.isValid) {
      this.lndwService.submitErrorMessage += this.uploadFileComponent.submitErrorMessage;
      validData = false;
    }

    if (this.applicant.displayErrorMessage().length > 0) {
      this.lndwService.submitErrorMessage += this.applicant.displayErrorMessage();
      validData = false;
    }

    if (!this.lndwService.agreedToTsAndCs) {
      this.lndwService.submitErrorMessage += 'Please select terms and conditions.';
      validData = false;
    }

    if (!validData) {
      return;
    }
    this.setApplicantData();
    this.applicationService.applicationData.isPaymentByCheque = this.isPaymentByCheque;
    this.lndwService.applicationData.toUpperCase();
    this.setWorkRequestData();
    this.setDescriptionOfWork();
    this.lndwService.applicationData.locationAddress = this.location.addressDetails.locationAddress || '1 MCNAB AVENUE, FOOTSCRAY';
    if (this.uploadFileComponent.uploadfilesViewmodel.isDropbox) {
      this.lndwService.workRequestViewModel.workrequestDetails.comment = 'Dropbox url: '
        + this.uploadFileComponent.uploadfilesViewmodel.dropboxUrl;
    }
    this.doSubmit(callback, this.applicationType);
  }

  abstract setDescriptionOfWork();

  abstract setWorkRequestData();

  abstract validateWorkRequest(validData: boolean);

  get ownerDetails(): User {
    return (<LndBase>this.lndwService.applicationData).owner;
  }

  newApplication(): void {
    window.location.reload();
    //super.newApplication();
    //this.uploadFileComponent.clearFiles();
    //this.owner.clearTitle();
    //this.owner.markValidationControlsAsUntouched();
  }

  get shouldDisplayLocation(): boolean {
    return this.activeIndex === 0;
  }

  get shouldDisplayWorkRequest(): boolean {
    return this.activeIndex === 1;
  }

  get shouldDisplayUploadFiles(): boolean {
    return this.activeIndex === 2;
  }

  get shouldDisplayOwner(): boolean {
    return this.activeIndex === 3;
  }

  get shouldDisplayApplicant(): boolean {
    return this.activeIndex === 4;
  }

  get shouldShowSubmitAndReview(): boolean {
    return this.activeIndex === 5;
  }

  get shouldDisplayPaymentForm(): boolean {
    // return this.isGuestUserLoggedIn && !this.isPaymentByCheque && this.activeIndex === 6;
    return !this.loginService.isUserBillLater() && !this.isPaymentByCheque && this.activeIndex === 6;
  }

  get shouldDisplayNextButton(): boolean {
    return this.activeIndex < 5;
  }

  get propertyDescription(): string {
    return this.location.addressDetails.locationAddress;
  }

  protected doSubmit(callback: any, appType: string): void {
    //this.executeSubmit(appType, callback, this.getTotalOrderAmount(), this.uploadFileComponent, !this.isPaymentByCheque);
    this.executeSubmit(appType, callback, this.getTotalOrderAmount(), this.uploadFileComponent, false);
  }

  get subdivisionYesrequired(): boolean {
    return this.lndwService.subdivisionYesrequired;
  }

  get subdivisionNorequired(): boolean {
    return this.lndwService.subdivisionNorequired;
  }

  set subdivisionYesrequired(v: boolean) {
    this.lndwService.subdivisionYesrequired = v;

    if (v) {
      this.lndwService.subdivisionNorequired = !v;
      if (this.spearReferenceControl) {
        this.spearReferenceControl.enable();
      }

      if (this.location) {
        this.location.disableControls(true);
      }
    } else {
      if (this.spearReferenceControl) {
        this.spearReferenceControl.disable();
      }
      if (this.location) {
        this.location.disableControls(false);
      }
    }
  }

  set subdivisionNorequired(v: boolean) {
    this.lndwService.subdivisionNorequired = v;

    if (v) {
      this.spearReference = '';
      this.lndwService.subdivisionYesrequired = !v;
      this.spearReferenceControl.disable();
      if (this.location) {
        this.location.disableControls(false);
      }
    } else {
      if (this.spearReferenceControl) {
        this.spearReferenceControl.enable();
      }
      if (this.location) {
        this.location.disableControls(true);
      }
    }
  }

  get spearReference(): string {
    if (this.lndwService && this.lndwService.workRequestViewModel && this.lndwService.workRequestViewModel.workrequestDetails) {
      return this.lndwService.workRequestViewModel.workrequestDetails.spearReference;
    }

    return '';
  }

  set spearReference(v: string) {
    if (this.lndwService && this.lndwService.workRequestViewModel && this.lndwService.workRequestViewModel.workrequestDetails) {
      this.lndwService.workRequestViewModel.workrequestDetails.spearReference = v;
    }
  }

  get isPaymentByCheque(): boolean {
    return this.lndwService.isPaymentByCheque;
  }

  set isPaymentByCheque(value: boolean) {
    this.lndwService.isPaymentByCheque = value;
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/lnd-w-form/lnd-w/lnd-base.component.ts